import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { useHistory, Link } from 'react-router-dom';

import { accessLocalStorage, exportSelectAllQueueMembers, exportDeleteQueueMember } from '../../../services';
import MembersTable from './components/MembersTable';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';
import './MembersList.css';
import './QueuesTable.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faPen, faTrash, faUsers } from '@fortawesome/free-solid-svg-icons';

function MembersQueuesList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [sortElements, setSortElements] = useState({ key: '', direction: 'ascending'});
  const [membersQueues, setMembersQueues] = useState(() => []);
  const [membersQueuesSelected, setMembersQueuesSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [filterText, setFilterText] = useState('');

  const history = useHistory();

  const fetchMemberQueues = async (idtenant) => {
    try {
      const membersQueuesList = await exportSelectAllQueueMembers();
      
      if(membersQueuesList === undefined || !Array.isArray(membersQueuesList)) {
        setLoading(false);
        setMembersQueues([]);
        return true;
      }
      
      let elements = membersQueuesList.map((element) => {
        const queueNameValue = element.queuename !== null && element.queuename !== undefined 
          ? String(element.queuename).trim() 
          : (element.queuename !== null && element.queuename !== undefined 
            ? String(element.queuename).trim() 
            : '');
        
        return {
          ...element,
          queueName: queueNameValue,
          endpoint: element.endpoint ? String(element.endpoint) : '',
          membername: element.membername || '',
          accountcode: element.accountcode || ''
        };
      });
      
      elements = idtenant.includes('vgs') 
        ? elements 
        : elements.filter((element) => element.accountcode && idtenant.includes(element.accountcode));
      
      setMembersQueues(elements);
      setLoading(false);
      return true;
    } catch (error) {
      setLoading(false);
      setMembersQueues([]);
      return false;
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const listQueuesMembers = await fetchMemberQueues(idtenant );
    return listQueuesMembers;
  }, []);

  const handleChangeSelectedMembersQueues = (element) => {
    setMembersQueuesSelected(element);
    setDisable(false);
  };

  const handleClickDelete = async () => {
    const sendDeleteMembersQueues = await exportDeleteQueueMember({ id: membersQueuesSelected });
    toggleIsHidden('#alert-confirm-membersqueues-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(membersQueuesSelected);
    return history.push('/config/fila/membros/lista/id');
  };


  useMemo(() => {
    let sortableItems = membersQueues;
    if (sortElements !== null) {
      sortableItems.sort((a, b) => {
        if(sortElements.key === 'endpoint' && sortElements.direction === 'ascending') return a[sortElements.key] - b[sortElements.key];
        if(sortElements.key === 'endpoint' && sortElements.direction === 'descending') return b[sortElements.key] - a[sortElements.key];
        
        if (a[sortElements.key] < b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortElements.key] > b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    setMembersQueues(sortableItems);
    return;
  }, [sortElements]);

  const sortedCalls = (key) => {
    let newDirection = sortElements.direction;
    if (sortElements.key === '' || sortElements.key !== key) {
      newDirection = 'descending';

      setSortElements((prevState) => prevState = { key, direction: newDirection });
      return;
    }
    if (sortElements.key === key && sortElements.direction === 'ascending') {
      newDirection = 'descending';
    } else {
      newDirection = 'ascending';
    }
    setSortElements((prevState) => prevState = { key, direction: newDirection });
    return;
  };

  const filteredMembers = membersQueues.filter((member) => {
    const searchText = filterText.toLowerCase();
    return (
      (member.endpoint && member.endpoint.toString().includes(searchText)) ||
      (member.membername && member.membername.toLowerCase().includes(searchText)) ||
      (member.queueName && member.queueName.toLowerCase().includes(searchText))
    );
  });

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="members-list-container">
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="members-list-header">
            <div className="members-list-title-wrapper">
              <svg className="members-list-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="members-list-title">Lista de Membros</h1>
                <p className="members-list-subtitle">Gerencie os membros dos grupos atendedores</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-confirm-membersqueues-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-confirm-membersqueues-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar o ramal/membro selecionado?
                <div className="alert-actions">
                  <button className="btn-alert btn-alert-confirm" type="submit" onClick={() => handleClickDelete()}>
                    <FontAwesomeIcon icon={faTrash} />
                    <span>Confirmar</span>
                  </button>
                  <button className="btn-alert btn-alert-cancel" type="submit" onClick={() => {
                    toggleIsHidden('#alert-confirm-membersqueues-delete');
                    toggleIsHidden('#buttons');
                  }}>
                    <FontAwesomeIcon icon={faTrash} />
                    <span>Cancelar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por ramal, nome do atendente ou fila..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredMembers.length} de {membersQueues.length} membro(s)
            </div>
          </div>

          <div className="queues-table-wrapper">
            <table className="queues-table">
              <thead className="queues-table-header">
                <tr>
                  <th>Selecione</th>
                  <th onClick={() => sortedCalls('endpoint')} style={{cursor: 'pointer'}}>
                    Ramal <FontAwesomeIcon icon={sortElements.key === 'endpoint' && sortElements.direction === 'descending' ? faArrowUp : faArrowDown} />
                  </th>
                  <th onClick={() => sortedCalls('membername')} style={{cursor: 'pointer'}}>
                    Nome Atendente <FontAwesomeIcon icon={sortElements.key === 'membername' && sortElements.direction === 'descending' ? faArrowUp : faArrowDown} />
                  </th>
                  <th onClick={() => sortedCalls('queueName')} style={{cursor: 'pointer'}}>
                    Nome da Fila <FontAwesomeIcon icon={sortElements.key === 'queueName' && sortElements.direction === 'descending' ? faArrowUp : faArrowDown} />
                  </th>
                  <th>Pausa</th>
                  <th>Prioridade</th>
                  <th>Sequência</th>
                  <th>Toca em Uso</th>
                  <th>Estado</th>
                  <th>Descanso</th>
                </tr>
              </thead>
              <tbody>
                {filteredMembers.map((member) => <MembersTable key={member.uniqueid} member={member} selectMember={handleChangeSelectedMembersQueues} />)}
              </tbody>
            </table>
          </div>

          <div id="buttons" className="queues-actions">
            <button className="btn-queue-action btn-view-queue" type="submit" onClick={() => handleClickUpdate()} disabled={disable}>
              <FontAwesomeIcon icon={faPen} />
              <span>Alterar</span>
            </button>
            <button
              className="btn-queue-action btn-delete-queue"
              type="submit"
              onClick={() => {
                toggleIsHidden('#alert-confirm-membersqueues-delete');
                toggleIsHidden('#buttons');
              }}
              disabled={disable}
            >
              <FontAwesomeIcon icon={faTrash} />
              <span>Deletar</span>
            </button>
          </div>
        </div>
      }
    </div>
  );
}

export default MembersQueuesList;
